import { format, startOfWeek } from 'date-fns'

/**
 * Calendar dates are stored as 'yyyy-MM-dd' in the user's local time zone.
 * Never derive them with toISOString(), which converts to UTC first and rolls
 * over to the next day in the evening for anyone west of Greenwich.
 */
export function toISODate(d: Date): string {
  return format(d, 'yyyy-MM-dd')
}

export function todayISO(): string {
  return toISODate(new Date())
}

/** The Monday starting the week containing `d`, as 'yyyy-MM-dd'. */
export function weekStartISO(d: Date = new Date()): string {
  return toISODate(startOfWeek(d, { weekStartsOn: 1 }))
}
